var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('p',[_vm._v(_vm._s(_vm.useValue(item)))]),_c('span',[_vm._v(_vm._s(_vm.useName(item)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }